import React from 'react';

/**
 * Print-only signature & stamp block.
 *
 * Hidden on screen; revealed via `@media print` (see index.css `.print-signature-block`).
 * Drop this at the bottom of any page that uses `window.print()` so the printed
 * document carries the clinician + patient signature lines and a clinic stamp
 * box — required for GDPR audit trails and most EU/Polish medical record laws.
 *
 * Props:
 *   - leftLabel: caption under the left signature line (default "Clinician / Provider")
 *   - rightLabel: caption under the right signature line (default "Patient")
 *   - showStamp: render the clinic stamp + date row (default true)
 */
export default function PrintSignatureBlock({
  leftLabel = 'Clinician / Provider',
  rightLabel = 'Patient',
  showStamp = true,
}) {
  return (
    <>
      <div className="print-signature-block" data-testid="print-signature-block">
        <div className="sig-line">{leftLabel}</div>
        <div className="sig-line">{rightLabel}</div>
      </div>
      {showStamp && (
        <div className="print-signature-block" data-testid="print-stamp-block" style={{ marginTop: 24 }}>
          <div className="stamp-box">Clinic stamp</div>
          <div style={{ alignSelf: 'end', fontSize: 11, color: '#7A827A' }}>Date: ___________________</div>
        </div>
      )}
    </>
  );
}
